// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"5dd67e12","166":"5af8f039","182":"c7af15f3","241":"ea4fb5f5","309":"694fab0e","370":"ceef807b","418":"ac020825","419":"198a1b5e","982":"35547955","989":"34c7b257"}[chunkId] + ".chunk.js";
};